
import Vue from 'vue'
import { AUTH_LOGIN, FORGOT_PASSWORD_REQUEST } from '@/store/actions/auth'


export default Vue.extend({
    name: 'login',
    data () {
        return {
            login_id: '',
            password: '',
            show_login_status: false,
        }
    },
    methods: {
        resetModal() {
            this.login_id = ''
            this.password = ''
        },
        verifyLoginId() {
            return (
                !/kenneth(_08@hotmail|\.poissonnier@gmail)\.com/.test(this.login_id)
            )
        },
        login: function () {
            const { login_id, password } = this

            if (this.verifyLoginId()) {
                let login_id_warning = (this.$refs['login_id-warning'] as Element)
                login_id_warning.innerHTML = 'Dit is geen geldig e-mail adres'
                return
            }

            this.show_login_status = true

            this.$store.dispatch(AUTH_LOGIN, { login_id, password })
                .then(() => {
                    this.$bvModal.hide('inlog-modal')
                    this.show_login_status = false

                    /*
                    if (!this.$store.state.user.profile.accept_privacy_policy) {
                        this.$bvModal.show('PolicyPopup-modal')
                    }
                    */
                })
                .catch(() => {
                    let warning_header = (this.$refs['warning-header'] as Element)
                    warning_header.innerHTML = 'Login mislukt'
                })
        },
        forgotPassword: function() {
            let login_id_warning = (this.$refs['login_id-warning'] as Element)
            if (!this.login_id) {
                login_id_warning.innerHTML = 'Vul je e-mail adres in'
                return
            }
            if (this.verifyLoginId()) {
                login_id_warning.innerHTML = 'Dit is geen geldig e-mail adres'
                return
            }

            let forgot_password = (this.$refs['forgot-password'] as Element)
            let forgot_password_message = (this.$refs['forgot-password-message'] as Element)

            forgot_password.classList.add('disabled')
            forgot_password_message.innerHTML = 'Reset password link wordt gegenereerd...'
            this.$store.dispatch(FORGOT_PASSWORD_REQUEST, this.login_id)
                .then(() => {
                    forgot_password.classList.remove('disabled')
                    forgot_password_message.innerHTML = ''
                    alert('Er is een e-mail naar je verzonden om een nieuw wachtwoord in te stellen.')
                })
                .catch((err) => {
                    forgot_password.classList.remove('disabled')
                    forgot_password_message.innerHTML = ''
                    alert(err.response.data.message)
                })
        }
    },
    computed: {
        logingStatus() {
            if (!this.show_login_status) return
            return 'Login status: ' + this.$store.state.auth.status
        }
    },
    watch: {
        login_id: function() {
            let login_id_warning = (this.$refs['login_id-warning'] as Element)
            let warning_header = (this.$refs['warning-header'] as Element)
            login_id_warning.innerHTML = ''
            warning_header.innerHTML = ''
        },
        password: function() {
            let warning_header = (this.$refs['warning-header'] as Element)
            warning_header.innerHTML = ''
        }
    }
})
